export default {
  th: {
    courseType: {
      NORMAL: 'ปกติ',
      INTER: 'นานาชาติ',
      ARCH: 'นานาชาติ(บางขุนเทียน)',
      RATC: 'ราชบุรี'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/i18n.js